<!--
  @file onboarding-blackout.component.html
  @description Template visual del sistema de Onboarding.

  Estructura:
  ┌─ .tour-overlay (fondo oscuro)
  │   ├─ .spotlight (elemento con box-shadow gigante que hace el "agujero" iluminado)
  │   └─ .tour-popover (tarjeta del tooltip)
  │       ├─ .popover-progress-bar (barra superior morada)
  │       ├─ .popover-body
  │       │   ├─ .step-badge ("1/4" con fondo lila)
  │       │   ├─ h3.popover-title (título en negrita)
  │       │   └─ p.popover-content (descripción en gris)
  │       └─ .popover-footer
  │           ├─ button.btn-skip
  │           └─ button.btn-next / button.btn-finish
  └─ (fin)
-->

<!-- El overlay completo solo se renderiza cuando el tour está activo -->
<div class="tour-overlay" *ngIf="isVisible && currentStep" role="dialog" aria-modal="true" [attr.aria-label]="'Tour paso ' + currentStepDisplay + ' de ' + totalSteps">
    <!-- ── Spotlight ──────────────────────────────────────────────────────── -->
    <!--
      Si el elemento objetivo fue encontrado, renderizamos el spotlight.
      Su box-shadow oscurece todo excepto el área donde está posicionado.
      Si el elemento NO fue encontrado, no hay spotlight (el overlay es 100% oscuro).
    -->
    <div
        class="spotlight"
        [class.spotlight--instant]="!spotlightAnimated"
        *ngIf="spotlightRect && !elementNotFound && !isCalculating"
        [style.top.px]="spotlightRect.top"
        [style.left.px]="spotlightRect.left"
        [style.width.px]="spotlightRect.width"
        [style.height.px]="spotlightRect.height"
        [style.border-radius.px]="spotlightRect.borderRadius"
    ></div>
    <!--
      Mientras el pipeline busca/espera el elemento objetivo (isCalculating), el overlay muestra un spinner
      en vez de quedarse oscuro sin feedback: con la API lenta la espera puede llegar al tope del
      MutationObserver. El fade-in retrasado del SCSS evita que parpadee en los cambios de paso normales.
    -->
    <div class="tour-loading" *ngIf="isCalculating" role="status" aria-label="Preparando el tour"></div>

    <!-- ── Popover ────────────────────────────────────────────────────────── -->
    <!--
      Clases de placement: 'placement-top', 'placement-bottom', 'placement-left', 'placement-right'
      Estas clases controlan la posición y dirección del caret (::before pseudo-elemento).
    -->
    <div
        class="tour-popover"
        *ngIf="!isCalculating"
        [ngClass]="['placement-' + currentPlacement, elementNotFound ? 'centered' : '']"
        [style.top]="popoverPosition.top"
        [style.left]="popoverPosition.left"
        [style.transform]="popoverPosition.transform"
        [style.--caret-x]="caretOffsetPx !== null ? caretOffsetPx + 'px' : null"
        role="document"
    >
        <div class="popover-inner">
            <!-- Barra de progreso superior -->
            <div class="popover-progress-track">
                <div class="popover-progress-bar" [style.width.%]="progressPercent"></div>
            </div>

            <!-- Cuerpo del popover -->
            <div class="popover-body">
                <!-- Badge con el paso actual -->
                <span class="step-badge">{{ currentStepDisplay }}/{{ totalSteps }}</span>

                <!-- Título -->
                <h3 class="popover-title">{{ currentStep.title }}</h3>

                <!-- Descripción -->
                <p class="popover-content">{{ currentStep.content }}</p>
            </div>

            <!-- Footer con botones -->
            <div class="popover-footer">
                <button id="tour-btn-skip" class="btn-skip" type="button" (click)="onSkip()" aria-label="Saltar tour">Skip</button>

                <!-- Botón "Siguiente" (pasos intermedios) -->
                <button id="tour-btn-next" class="btn-next" type="button" *ngIf="!isLastStep" (click)="onNext()" aria-label="Siguiente paso">
                    Siguiente
                    <span class="btn-arrow" aria-hidden="true">→</span>
                </button>

                <!-- Botón "Finalizar" (último paso) -->
                <button id="tour-btn-finish" class="btn-finish" type="button" *ngIf="isLastStep" (click)="onFinish()" aria-label="Finalizar tour">Finalizar</button>
            </div>
        </div>
    </div>
</div>
